import { SeoMapper } from '@search/router/src';

export const livingTenantMapper = new SeoMapper('livingTenantMapper', {
    UNKNOWN: 'UNKNOWN',
    CHILDREN_ALLOWED: 'CHILDREN_ALLOWED',
    PETS_ALLOWED: 'PETS_ALLOWED',
} as const);
